import { render, staticRenderFns } from "./rascunho.vue?vue&type=template&id=17f30c08"
import script from "./rascunho.ts?vue&type=script&lang=js&external"
export * from "./rascunho.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\TafStore.PharmUP.Client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('17f30c08')) {
      api.createRecord('17f30c08', component.options)
    } else {
      api.reload('17f30c08', component.options)
    }
    module.hot.accept("./rascunho.vue?vue&type=template&id=17f30c08", function () {
      api.rerender('17f30c08', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/child/rascunho/rascunho.vue"
export default component.exports